export default (that) => [
  {
    field: "seq",
    minWidth: 40,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "col-opt",
    title: that.$l("INDEX.table_label_operation") || "操作",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    slots: {
      default: "opt",
    },
  },
  {
    title:  that.$l('orderpackage_table_lable_product_type')||"产品类型",
    field: "v_packageGoodsType",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('orderpackage_table_lable_packaging_type')||"包装类型",
    field: "v_packageType",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.material_choose_material_no')||"物料编号",
    field: "materialNo",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsNo')||"产品编号",
    field: "orderGoodsNo",
    headerAlign: "center",
    align: "center",
    minWidth: 220,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goods_spec_no')||"产品规格编号",
    field: "orderGoodsSpecNo",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('orderpackage_table_lable_packing_quantity')||"装箱数量",
    field: "qty",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by')||"修改人",
    field: "modifyByName",
    headerAlign: "center",
    align: "center",
    minWidth: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:that.$l('INDEX.bill_time_modify_time')||"修改时间",
    field: "modifyTime",
    headerAlign: "center",
    align: "center",
    minWidth: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
